import { Directive } from '@angular/core';
import { ElementRef, HostListener } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[opsFocusSelect]',
})
export class OpsFocusSelectDirective {
  constructor(elementRef: ElementRef) {
    //
  }

  @HostListener('focus', ['$event'])
  change(event: { target: { select: () => any } }) {
    // setTimeout(() => event.target.select(), 1);
  }
}
